<form [formGroup]="paymentService.formGroup" class="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-4">
    <kendo-formfield class="numeric-field">
        <kendo-label class="form-label" [text]="'fundingAmount.approved' | translate" infotooltip="fundingAmount.approved"></kendo-label>
        <kendo-numerictextbox
            [disabled]="true"
            [spinners]="false"
            [autoCorrect]="true"
            [format]="currencyFormatOptions"
            appinfotext="fundingAmount.approved"
            formControlName="foerdersummeBewilligt"
            ></kendo-numerictextbox>
    </kendo-formfield>

    <kendo-formfield class="numeric-field">
        <kendo-label class="form-label" [text]="'fundingAmount.paymentsMade' | translate" infotooltip="fundingAmount.paymentsMade"></kendo-label>
        <kendo-numerictextbox
            [disabled]="true"
            formControlName="getaetigteZahlungen"
            [autoCorrect]="true"
            [format]="currencyFormatOptions"
            appinfotext="fundingAmount.paymentsMade"
            [spinners]="false"
            ></kendo-numerictextbox>
    </kendo-formfield>

    <kendo-formfield class="numeric-field">
        <kendo-label class="form-label" [text]="'fundingAmount.pending' | translate" infotooltip="fundingAmount.pending"></kendo-label>
        <kendo-numerictextbox
            [disabled]="true"
            formControlName="ausstehendeZahlungen"
            [autoCorrect]="true"
            [format]="currencyFormatOptions"
            appinfotext="fundingAmount.pending"
            [spinners]="false"
            ></kendo-numerictextbox>
    </kendo-formfield>

    <kendo-formfield class="numeric-field">
        <kendo-label class="form-label" [text]="'fundingAmount.repayments' | translate" infotooltip="fundingAmount.pending"></kendo-label>
        <kendo-numerictextbox
            [disabled]="true"
            formControlName="rueckzahlungen"
            [autoCorrect]="true"
            [format]="currencyFormatOptions"
            appinfotext="fundingAmount.pending"
            [spinners]="false"
            ></kendo-numerictextbox>
    </kendo-formfield>

    <kendo-formfield *ngIf="showFoerdersummeOffen" class="numeric-field">
        <kendo-label class="form-label" [text]="'fundingAmount.open' | translate" infotooltip="fundingAmount.open"></kendo-label>
        <kendo-numerictextbox
            [disabled]="true"
            formControlName="foerdersummeOffen"
            [autoCorrect]="true"
            [format]="currencyFormatOptions"
            appinfotext="fundingAmount.open"
            [spinners]="false"
            ></kendo-numerictextbox>
    </kendo-formfield>
</form>